<div [formGroup]="themeForm">
  <div class="notification-panel">
    <div class="notification-panel-text">Give your theme a name then adjust the colors for the different page elements
      and sections
    </div>
  </div>

  <div class="actions">
    <mdb-form-control class="form-fill w-50" >
      <app-mdbp-input mdbInput formControlName="themeName" label='Theme Name'></app-mdbp-input>
      <span class="form-fill-error"  *ngIf="themeForm.controls.themeName.hasError('required') && themeForm.controls.themeName.touched ">Please provide Theme Name</span>
    </mdb-form-control>
    <div class="buttons">
      <button class="btn btn--paybee btn--outline-transparent mr-2" (click)="onCancel()">Cancel</button>
      <button class="btn btn--paybee btn--primary" [disabled]="themeForm.invalid" (click)="saveTheme()">Save Theme</button>
    </div>
  </div>

  <div class="navigation-bar-section">
    <div class="section-title">General Page Configuration</div>
    <div class="section-container">
      <div class="section-configuration">
        <div class="d-flex align-items-center p-2 m-1">
          <label for="pageBg" class="form-label form-label-colorpicker">Page Background:</label>
          <input type="color" class="form-control form-control-color" formControlName="pageBg" id="pageBg">
        </div>
      </div>
    </div>
  </div>

  <div class="navigation-bar-section">
    <div class="section-title">Navigation Bar Section</div>
    <div class="section-container">
      <div class="section-visualization" [style.backgroundColor]="themeForm.get('navBg').value">
        <div class="left">
          <div class="logo"></div>
          <div class="title" [style.color]="themeForm.get('navRegularLink').value">Organization Name</div>
        </div>

        <div class="navlinks">
          <div class="navlink-item" [style.color]="themeForm.get('navRegularLink').value">Link 1</div>
          <div class="navlink-item" [style.color]="themeForm.get('navActiveLink').value">Active Link 2</div>
          <div class="navlink-item" [style.color]="themeForm.get('navRegularLink').value">Link 3</div>
          <div class="navlink-item" [style.color]="themeForm.get('navRegularLink').value">Contact</div>
        </div>
      </div>
      <div class="section-configuration">
        <div class="d-flex align-items-center p-2 m-1">
          <label for="navBg" class="form-label form-label-colorpicker">Background:</label>
          <input type="color" class="form-control form-control-color" formControlName="navBg" id="navBg">
        </div>

        <div class="d-flex align-items-center p-2 m-1">
          <label for="navRegularLink" class="form-label form-label-colorpicker">Regular link Color:</label>
          <input type="color" class="form-control form-control-color" formControlName="navRegularLink" id="navRegularLink" >
        </div>

        <div class="d-flex align-items-center p-2 m-1">
          <label for="navActiveLink" class="form-label form-label-colorpicker">Active link Color:</label>
          <input type="color" class="form-control form-control-color" formControlName="navActiveLink" id="navActiveLink">
        </div>

      </div>
    </div>
  </div>

  <div class="header-section">
    <div class="section-title">Header</div>
    <div class="section-container">
      <ng-container *ngIf="headerType === 1">
        <div class="section-visualization type-1"
             [style.backgroundColor]="themeForm.get('informationContainerBg').value">
          <div class="title-container">
            <div class="title-wrapper">
              <div class="title" [style.color]="themeForm.get('informationContainerTextColor').value">Event Title</div>
              <div class="time" [style.backgroundColor]="themeForm.get('informationContainerDate').value"></div>
              <div class="address"></div>
            </div>
            <div class="button-wrapper">
              <div class="event-desc"
                   [style.color]="themeForm.get('informationContainerTextColor').value">
                Using Lorem ipsum to focus attention on graphic elements in a webpage design proposal.
                In publishing and graphic design.
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-end col-3 p-3" [style]="getTriangleStyles()">
              <div class="button-wrapper">
                <div class="button" [style.backgroundColor]="themeForm.get('informationContainerButtonBg').value">
                  <span [style.color]="themeForm.get('informationContainerButtonText').value">Register</span>
                </div>
                <div class="share-icons">
                  <div class="icon"
                       [style.backgroundColor]="themeForm.get('informationContainerShareIconsText').value"></div>
                  <div class="icon"
                       [style.backgroundColor]="themeForm.get('informationContainerShareIconsText').value"></div>
                  <div class="icon"
                       [style.backgroundColor]="themeForm.get('informationContainerShareIconsText').value"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="headerType === 2">
        <div [style.backgroundColor]="themeForm.get('informationContainerBg').value" class="section-visualization type-2">
          <div class="col-6 px-0">
            <div class="preview-image-2"></div>
          </div>

          <div class="col-6 p-3 right">
            <div class="title-container">
              <div class="title-wrapper">
                <div class="title" [style.color]="themeForm.get('informationContainerTextColor').value">Event Title</div>
                <div class="time" [style.backgroundColor]="themeForm.get('informationContainerDate').value"></div>
                <div class="address"></div>
              </div>
            </div>
            <div class="event-desc"
                 [style.color]="themeForm.get('informationContainerTextColor').value">
              Using Lorem ipsum to focus attention on graphic elements in a webpage design proposal.
              In publishing and graphic design.

              <div class="button-wrapper">
                <div class="button" [style.backgroundColor]="themeForm.get('informationContainerButtonBg').value">
                  <span [style.color]="themeForm.get('informationContainerButtonText').value">Register</span>
                </div>

                <div class="share-icons">
                  <div class="icon"
                       [style.backgroundColor]="themeForm.get('informationContainerShareIconsText').value"></div>
                  <div class="icon"
                       [style.backgroundColor]="themeForm.get('informationContainerShareIconsText').value"></div>
                  <div class="icon"
                       [style.backgroundColor]="themeForm.get('informationContainerShareIconsText').value"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="headerType === 3">
        <div [style.backgroundColor]="themeForm.get('informationContainerBg').value" class="section-visualization type-3">
          <div class="col-6 p-3 right">
            <div class="title-container">
              <div class="title-wrapper">
                <div class="title" [style.color]="themeForm.get('informationContainerTextColor').value?.rgba">Event Title</div>
                <div class="time" [style.backgroundColor]="themeForm.get('informationContainerDate').value?.rgba"></div>
                <div class="address"></div>
              </div>
            </div>
            <div class="event-desc"
                 [style.color]="themeForm.get('informationContainerTextColor').value">
              Using Lorem ipsum to focus attention on graphic elements in a webpage design proposal.
              In publishing and graphic design.
              <div class="button-wrapper">
                <div class="button" [style.backgroundColor]="themeForm.get('informationContainerButtonBg').value">
                  <span [style.color]="themeForm.get('informationContainerButtonText').value">Register</span>
                </div>
                <div class="share-icons">
                  <div class="icon"
                       [style.backgroundColor]="themeForm.get('informationContainerShareIconsText').value"></div>
                  <div class="icon"
                       [style.backgroundColor]="themeForm.get('informationContainerShareIconsText').value"></div>
                  <div class="icon"
                       [style.backgroundColor]="themeForm.get('informationContainerShareIconsText').value"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 px-0">
            <div class="preview-image-3"></div>
          </div>

        </div>
      </ng-container>
      <ng-container *ngIf="headerType === 4">
        <div [style.backgroundColor]="themeForm.get('informationContainerBg').value" class="section-visualization type-4">
          <div class="col-6 p-3 right">
            <div class="title-container">
              <div class="title-wrapper">
                <div class="title" [style.color]="themeForm.get('informationContainerTextColor').value">Event Title</div>
                <div class="time" [style.backgroundColor]="themeForm.get('informationContainerDate').value"></div>
                <div class="address"></div>
              </div>
            </div>
            <div class="event-desc"
                 [style.color]="themeForm.get('informationContainerTextColor').value">
              <div class="button-wrapper">
                <div class="button mr-3" [style.backgroundColor]="themeForm.get('informationContainerButtonBg').value">
                  <span [style.color]="themeForm.get('informationContainerButtonText').value">Register</span>
                </div>

                <div class="button" [style.backgroundColor]="themeForm.get('informationContainerButtonBg').value">
                  <span [style.color]="themeForm.get('informationContainerButtonText').value">Learn More</span>
                </div>
              </div>
              <div class="w-100">
                <div class="share-icons">
                  <div class="icon"
                       [style.backgroundColor]="themeForm.get('informationContainerShareIconsText').value"></div>
                  <div class="icon"
                       [style.backgroundColor]="themeForm.get('informationContainerShareIconsText').value"></div>
                  <div class="icon"
                       [style.backgroundColor]="themeForm.get('informationContainerShareIconsText').value"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 px-0">
            <div class="preview-image-4"></div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="headerType === 5">
        <div class="section-visualization type-5">
          <div class="col-12 share-wrapper">
            <div class="share-icons">
              <div class="icon" [style.backgroundColor]="themeForm.get('informationContainerShareIconsText').value"></div>
              <div class="icon" [style.backgroundColor]="themeForm.get('informationContainerShareIconsText').value"></div>
              <div class="icon" [style.backgroundColor]="themeForm.get('informationContainerShareIconsText').value"></div>
            </div>
          </div>
          <div class="col-12">
            <div class="title-container">
              <div class="title-wrapper">
                <div class="title" [style.color]="themeForm.get('informationContainerTextColor').value">Event Title</div>
                <div class="time" [style.backgroundColor]="themeForm.get('informationContainerDate').value"></div>
                <div class="address"></div>
              </div>
            </div>
            <div class="event-desc">
              <div class="button-wrapper">
                <div class="button mr-4" [style.backgroundColor]="themeForm.get('informationContainerButtonBg').value">
                  <span [style.color]="themeForm.get('informationContainerButtonText').value">Register</span>
                </div>

                <div class="button" [style.backgroundColor]="themeForm.get('informationContainerButtonBg').value">
                  <span [style.color]="themeForm.get('informationContainerButtonText').value">Learn More</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="preview-image-4"></div>
          </div>
        </div>
      </ng-container>

      <div class="section-configuration">
        <div class="w-100 mb-2">
          <div class="d-flex align-items-center p-2 m-1">
            <label for="informationContainerBg" class="form-label form-label-colorpicker">Background:</label>
            <input type="color" class="form-control form-control-color" formControlName="informationContainerBg" id="informationContainerBg">
          </div>

          <div class="d-flex align-items-center p-2 m-1">
            <label for="informationContainerRightTriangleBg" class="form-label form-label-colorpicker">Header Triangle Background:</label>
            <input type="color" class="form-control form-control-color" formControlName="informationContainerRightTriangleBg" id="informationContainerRightTriangleBg">
          </div>

          <div class="d-flex align-items-center p-2 m-1">
            <label for="informationContainerTextColor" class="form-label form-label-colorpicker">Text Color:</label>
            <input type="color" class="form-control form-control-color" formControlName="informationContainerTextColor" id="informationContainerTextColor">
          </div>
        </div>
        <div class="w-100 mb-2">
          <div class="d-flex align-items-center p-2 m-1">
            <label for="informationContainerButtonBg" class="form-label form-label-colorpicker">Register Button Background:</label>
            <input type="color" class="form-control form-control-color" formControlName="informationContainerButtonBg" id="informationContainerButtonBg">
          </div>

          <div class="d-flex align-items-center p-2 m-1">
            <label for="informationContainerButtonText" class="form-label form-label-colorpicker">Register Button Text Color:</label>
            <input type="color" class="form-control form-control-color" formControlName="informationContainerButtonText" id="informationContainerButtonText">
          </div>
        </div>
        <div class="w-100 mb-2">
          <div class="d-flex align-items-center p-2 m-1">
            <label for="informationContainerDate" class="form-label form-label-colorpicker">Header Date:</label>
            <input type="color" class="form-control form-control-color" formControlName="informationContainerDate" id="informationContainerDate">
          </div>

          <div class="d-flex align-items-center p-2 m-1">
            <label for="informationContainerShareIconsText" class="form-label form-label-colorpicker">Share Icons</label>
            <input type="color" class="form-control form-control-color" formControlName="informationContainerShareIconsText" id="informationContainerShareIconsText">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="sponsors-section">
    <div class="section-title">Sponsors</div>
    <div class="section-container">
      <div class="section-visualization" [style.backgroundColor]="themeForm.get('sponsorsBg').value">
        <div class="title" [style.color]="themeForm.get('sponsorsTitle').value">Sponsors</div>

        <div class="sponsor-list">
          <div class="sponsor-item-container">
            <div class="sponsor-item"></div>
            <div class="sponsor-item-name" [style.color]="themeForm.get('sponsorsText').value">Sponsor Name</div>
          </div>
          <div class="sponsor-item-container">
            <div class="sponsor-item"></div>
            <div class="sponsor-item-name" [style.color]="themeForm.get('sponsorsText').value">Sponsor Name</div>
          </div>
          <div class="sponsor-item-container">
            <div class="sponsor-item"></div>
            <div class="sponsor-item-name" [style.color]="themeForm.get('sponsorsText').value">Sponsor Name</div>
          </div>
        </div>
      </div>

      <div class="section-configuration">
        <div class="d-flex align-items-center p-2 m-1">
          <label for="sponsorsBg" class="form-label form-label-colorpicker">Background:</label>
          <input type="color" class="form-control form-control-color" formControlName="sponsorsBg" id="sponsorsBg">
        </div>

        <div class="d-flex align-items-center p-2 m-1">
          <label for="sponsorsTitle" class="form-label form-label-colorpicker">Title Color:</label>
          <input type="color" class="form-control form-control-color" formControlName="sponsorsTitle" id="sponsorsTitle">
        </div>

        <div class="d-flex align-items-center p-2 m-1">
          <label for="sponsorsText" class="form-label form-label-colorpicker">Text Color:</label>
          <input type="color" class="form-control form-control-color" formControlName="sponsorsText" id="sponsorsText">
        </div>
      </div>
    </div>
  </div>

  <div class="auction-section">
    <div class="section-title">Auction Section</div>
    <div class="section-container">
      <div class="section-visualization" [style.backgroundColor]="themeForm.get('auctionBg').value">
        <div class="title" [style.color]="themeForm.get('auctionText').value">Section Name</div>

        <div class="auction-items">
          <div class="auction-item"></div>
          <div class="auction-item"></div>
          <div class="auction-item"></div>
          <div class="auction-item"></div>
          <div class="auction-item"></div>
          <div class="auction-next-icon"><i class="fa-solid fa-angle-right"></i></div>
        </div>
      </div>

      <div class="section-configuration">
        <div class="d-flex align-items-center p-2 m-1">
          <label for="auctionBg" class="form-label form-label-colorpicker">Auction Background:</label>
            <input type="color" class="form-control form-control-color" formControlName="auctionBg" id="auctionBg">
        </div>

        <div class="d-flex align-items-center p-2 m-1">
          <label for="auctionText" class="form-label form-label-colorpicker">Text Color:</label>
          <input type="color" class="form-control form-control-color" formControlName="auctionText" id="auctionText">
        </div>
      </div>
    </div>
  </div>

  <div class="slideshow-section">
    <div class="section-title">Slideshow Section</div>
    <div class="section-container">
      <div class="section-visualization" [style.backgroundColor]="themeForm.get('slideShowBg').value">
        <div class="title" [style.color]="themeForm.get('slideShowText').value">Title</div>

        <div class="slide-items">
          <div class="slide-item-prev"></div>
          <div class="slide-item"></div>
          <div class="slide-item-next"></div>
        </div>
      </div>

      <div class="section-configuration">
        <div class="d-flex align-items-center p-2 m-1">
          <label for="slideShowBg" class="form-label form-label-colorpicker">Background:</label>
          <input type="color" class="form-control form-control-color" formControlName="slideShowBg" id="slideShowBg">
        </div>

        <div class="d-flex align-items-center p-2 m-1">
          <label for="slideShowText" class="form-label form-label-colorpicker">Text Color:</label>
          <input type="color" class="form-control form-control-color" formControlName="slideShowText" id="slideShowText">
        </div>
      </div>
    </div>
  </div>

  <div class="donation-section">
    <div class="section-title">Campaign Section</div>
    <div class="section-container">
      <div class="row section-visualization"
           [style.backgroundColor]="themeForm.get('donationCampaignSectionBg').value">
        <div class="col-6">
          <div class="preview-image"></div>
        </div>

        <div class="col-6 right">
          <div class="title" [style.color]="themeForm.get('donationCampaignSectionText').value">Title</div>
          <div class="text" [style.color]="themeForm.get('donationCampaignSectionText').value">Using Lorem ipsum
            to focus attention on graphic elements in a webpage design proposal. In publishing and graphic design, Lorem
            ipsum is a placeholder text commonly used to demonstrate commonly used to demonstrate commonly used to
            demonstrate
          </div>
          <div [style.backgroundColor]="themeForm.get('donationCampaignButtonBg').value" class="button">
            <span [style.color]="themeForm.get('donationCampaignButtonText').value">Donate</span>
          </div>
        </div>

      </div>
      <div class="section-configuration">
        <div class="w-100 mb-2">
          <div class="d-flex align-items-center p-2 m-1">
            <label for="donationCampaignButtonBg" class="form-label form-label-colorpicker">Button Background:</label>
            <input type="color" class="form-control form-control-color" formControlName="donationCampaignButtonBg" id="donationCampaignButtonBg">
          </div>
          <div class="d-flex align-items-center p-2 m-1">
            <label for="donationCampaignButtonText" class="form-label form-label-colorpicker">Button Text Color:</label>
            <input type="color" class="form-control form-control-color" formControlName="donationCampaignButtonText" id="donationCampaignButtonText">
          </div>
        </div>

        <div class="w-100 mb-2">
          <div class="d-flex align-items-center p-2 m-1">
            <label for="donationCampaignSectionBg" class="form-label form-label-colorpicker">Background:</label>
            <input type="color" class="form-control form-control-color" formControlName="donationCampaignSectionBg" id="donationCampaignSectionBg">
          </div>
          <div class="d-flex align-items-center p-2 m-1">
            <label for="donationCampaignSectionText" class="form-label form-label-colorpicker">Text Color:</label>
            <input type="color" class="form-control form-control-color" formControlName="donationCampaignSectionText" id="donationCampaignSectionText">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="text-section">
    <div class="section-title">Text Section</div>
    <div class="section-container">
      <div class="section-visualization" [style.backgroundColor]="themeForm.get('textSectionBg').value">
        <div class="title" [style.color]="themeForm.get('textSectionTitle').value">Title</div>
        <div class="text" [style.color]="themeForm.get('textSectionText').value">Using Lorem ipsum to focus
          attention on graphic elements in a webpage design proposal. In publishing and graphic design, Lorem ipsum is a
          placeholder text commonly used to demonstrate commonly used to demonstrate commonly used to demonstrate
        </div>
      </div>
      <div class="section-configuration">
        <div class="d-flex align-items-center p-2 m-1">
          <label for="textSectionBg" class="form-label form-label-colorpicker">Background:</label>
          <input type="color" class="form-control form-control-color" formControlName="textSectionBg" id="textSectionBg">
        </div>

        <div class="d-flex align-items-center p-2 m-1">
          <label for="textSectionText" class="form-label form-label-colorpicker">Text Color:</label>
          <input type="color" class="form-control form-control-color" formControlName="textSectionText" id="textSectionText">
        </div>

        <div class="d-flex align-items-center p-2 m-1">
          <label for="textSectionTitle" class="form-label form-label-colorpicker">Title Color:</label>
          <input type="color" class="form-control form-control-color" formControlName="textSectionTitle" id="textSectionTitle">
        </div>
      </div>
    </div>
  </div>

  <div class="faq-section">
    <div class="section-title">FAQ Section</div>
    <div class="section-container">
      <div class="section-visualization" [style.backgroundColor]="themeForm.get('faqSectionBg').value">
        <div class="title" [style.color]="themeForm.get('faqSectionTitle').value">Title</div>
        <div class="faq-item" [style.backgroundColor]="themeForm.get('faqSectionItemBg').value">
          <span [style.color]="themeForm.get('faqSectionItemText').value">Using Lorem ipsum to focus attention on graphic elements in a webpage design proposal.</span>
        </div>
        <div class="faq-item" [style.backgroundColor]="themeForm.get('faqSectionItemBg').value">
          <span [style.color]="themeForm.get('faqSectionItemText').value">Using Lorem ipsum to focus attention on graphic elements in a webpage design proposal.</span>
        </div>
      </div>
      <div class="section-configuration">
        <div class="w-100 mb-2">
          <div class="d-flex align-items-center p-2 m-1">
            <label for="faqSectionBg" class="form-label form-label-colorpicker">Background:</label>
            <input type="color" class="form-control form-control-color" formControlName="faqSectionBg" id="faqSectionBg">
          </div>

          <div class="d-flex align-items-center p-2 m-1">
            <label for="faqSectionItemBg" class="form-label form-label-colorpicker">Item Background:</label>
            <input type="color" class="form-control form-control-color" formControlName="faqSectionItemBg" id="faqSectionItemBg">
          </div>

        </div>

        <div class="w-100 mb-2">
          <div class="d-flex align-items-center p-2 m-1">
            <label for="faqSectionTitle" class="form-label form-label-colorpicker">Title Color:</label>
            <input type="color" class="form-control form-control-color" formControlName="faqSectionTitle" id="faqSectionTitle">

          </div>

          <div class="d-flex align-items-center p-2 m-1">
            <label for="faqSectionItemText" class="form-label form-label-colorpicker">Item Text Color:</label>
            <input type="color" class="form-control form-control-color" formControlName="faqSectionItemText" id="faqSectionItemText">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="video-section">
    <div class="section-title">Video Section</div>
    <div class="section-container">
      <div class="section-visualization" [style.backgroundColor]="themeForm.get('videoSectionBg').value">
        <div class="col-6 left">
          <div class="title" [style.color]="themeForm.get('videoSectionText').value">Title</div>
          <div class="text" [style.color]="themeForm.get('videoSectionText').value">Using Lorem ipsum to focus
            attention on graphic elements in a webpage design proposal. In publishing and graphic design, Lorem ipsum is
            a placeholder text commonly used to demonstrate commonly used to demonstrate commonly used to demonstrate
          </div>
        </div>
        <div class="col-6 right">
          <div class="video-preview"></div>
        </div>
      </div>
      <div class="section-configuration">
        <div class="d-flex align-items-center p-2 m-1">
          <label for="videoSectionBg" class="form-label form-label-colorpicker">Background:</label>
          <input type="color" class="form-control form-control-color" formControlName="videoSectionBg" id="videoSectionBg">
        </div>

        <div class="d-flex align-items-center p-2 m-1">
          <label for="videoSectionText" class="form-label form-label-colorpicker">Text Color:</label>
          <input type="color" class="form-control form-control-color" formControlName="videoSectionText" id="videoSectionText">
        </div>
      </div>
    </div>
  </div>

  <div class="image-section">
    <div class="section-title">Image Section</div>
    <div class="section-container">
      <div class="section-visualization" [style.backgroundColor]="themeForm.get('imageSectionBg').value">
        <div class="col-6 left">
          <div class="title" [style.color]="themeForm.get('imageSectionText').value">Title</div>
          <div class="text" [style.color]="themeForm.get('imageSectionText').value">Using Lorem ipsum to focus
            attention on graphic elements in a webpage design proposal. In publishing and graphic design, Lorem ipsum is
            a placeholder text commonly used to demonstrate commonly used to demonstrate commonly used to demonstrate
          </div>
        </div>
        <div class="col-6 right">
          <div class="image-preview"></div>
        </div>
      </div>
      <div class="section-configuration">
        <div class="d-flex align-items-center p-2 m-1">
          <label for="imageSectionBg" class="form-label form-label-colorpicker">Background:</label>
          <input type="color" class="form-control form-control-color" formControlName="imageSectionBg" id="imageSectionBg">
        </div>

        <div class="d-flex align-items-center p-2 m-1">
          <label for="imageSectionText" class="form-label form-label-colorpicker">Text Color:</label>
          <input type="color" class="form-control form-control-color" formControlName="imageSectionText" id="imageSectionText">
        </div>
      </div>
    </div>
  </div>

  <div class="org-info-section">
    <div class="section-title">Org Information Section</div>
    <div class="section-container">
      <div class="row section-visualization"
           [style.backgroundColor]="themeForm.get('orgInfoSectionBg').value">
        <div class="col-3">
          <div class="preview-image"></div>
        </div>

        <div class="col-9 right">
          <div class="title" [style.color]="themeForm.get('orgInfoSectionText').value">Title</div>
          <div class="text" [style.color]="themeForm.get('orgInfoSectionText').value">Using Lorem ipsum
            to focus attention on graphic elements in a webpage design proposal. In publishing and graphic design.
          </div>
        </div>

      </div>
      <div class="section-configuration">
        <div class="d-flex align-items-center p-2 m-1">
          <label for="orgInfoSectionBg" class="form-label form-label-colorpicker">Background:</label>
          <input type="color" class="form-control form-control-color" formControlName="orgInfoSectionBg" id="orgInfoSectionBg">

        </div>
        <div class="d-flex align-items-center p-2 m-1">
          <label for="orgInfoSectionText" class="form-label form-label-colorpicker">Text Color:</label>
          <input type="color" class="form-control form-control-color" formControlName="orgInfoSectionText" id="orgInfoSectionText">

        </div>
      </div>
    </div>
  </div>

  <div class="footer-section">
    <div class="section-title">Footer</div>
    <div class="section-container">
      <div class="section-visualization" [style.backgroundColor]="themeForm.get('footerBg').value">
        <div class="left">
          <div class="title" [style.color]="themeForm.get('footerText').value">https://paybee.io</div>
        </div>
      </div>
      <div class="section-configuration">
        <div class="d-flex align-items-center p-2 m-1">
          <label for="footerBg" class="form-label form-label-colorpicker">Background:</label>
          <input type="color" class="form-control form-control-color" formControlName="footerBg" id="footerBg">
        </div>

        <div class="d-flex align-items-center p-2 m-1">
          <label for="footerText" class="form-label form-label-colorpicker">Text Color:</label>
          <input type="color" class="form-control form-control-color" formControlName="footerText" id="footerText" title="Text Color:">
        </div>
      </div>
    </div>
  </div>
</div>
